<template>
  <div>
    <div class="copyright-search-wrap table-search-top">
      <input
        v-model="keyword"
        class="copyright-search"
        type="search"
        placeholder="アーティスト検索">
    </div>
    <div
      v-if="searchStatus === 1"
      class="artist-list">
      <p class="artist-not-exist">
        このキーワードのアーティストは登録されていません。
      </p>
    </div>
    <div
      v-if="searchStatus === 0"
      class="artist-list">
      <p class="artist-not-exist">
        アーティストが登録されていません。
      </p>
    </div>
    <div
      ref="scrollComponent"
      :class="{'infinite-scroll-container': artists.length > 0}"
      :style="artists.length > 9 ? { height: '400px' } : { height: 'fit-content' }">
      <div
        v-if="artists.length > 0"
        class="c-artist-list">
        <a
          v-for="item in artists"
          :key="item.id"
          class="scrollable-artist-list"
          href="#"
          @click.prevent="onSelectArtist(item)">
          <div
            :style="`background-image: url(/images/${item.image_path})`"
            class="pic">
          </div>
          <span class="artist-list__name_text scrollable-artist-list-name">
            {{ item.name_ja }}
          </span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'SearchableFeatArtistList',
  props: {
    artists: {
      type: Array,
      default: () => [],
    },
    lastPage: {
      type: Boolean,
      required: true,
    },
    belongsTo: {
      type: String,
      required: true,
    },
    searchStatus: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      keyword: '',
      page: 1,
    }
  },
  watch: {
    keyword(newSearchValue) {
      this.$emit('search', { keyword: newSearchValue, belongsTo: this.belongsTo })
    },
  },
  mounted() {
    if (this.page === 1) {
      this.$emit('handle', this.belongsTo)
    }
    const element = this.$refs.scrollComponent
    element.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    const element = this.$refs.scrollComponent
    element.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    onSelectArtist(data) {
      this.$emit('notify', { data, belongsTo: this.belongsTo })
    },
    handleScroll() {
      const element = this.$refs.scrollComponent
      const sH = element.scrollHeight
      if ((sH) === (element.scrollTop + 398) && this.lastPage === false) {
        this.page += 1
        this.$emit('pagination', {
          page: this.page,
          belongsTo: this.belongsTo,
        })
      }
    },
  },
}
</script>
<style scoped>

.copyright-search-wrap {
  background-color: white;
}
</style>
